import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from 'src/app/app.service';
import {
  FIAT_AMOUNT_DECIMALS,
  isStablecoin,
  isTwoDecimalCurrency,
  roundAmount,
  trimTrailingZeros,
} from '../utils/cashier-amount';
import { CurrencyValuePipe } from './currency-value.pipe';

/**
 * 收銀台金額顯示：法幣與穩定幣四捨五入到 2 位小數並移除結尾的 0（`20.000000 USDT` → `20`、`20.125` → `20.13`），
 * 其餘加密貨幣、千分位與 M 簡寫沿用 currencyValue。
 */
@Pipe({
  name: 'cashierAmount',
  pure: false,
})
export class CashierAmountPipe implements PipeTransform {
  // 使用獨立實例：currencyValue 的快取只看 (value, currency)，與全域共用實例混用 toFixed 會互相污染
  private currencyValuePipe: CurrencyValuePipe;

  constructor(private appService: AppService) {
    this.currencyValuePipe = new CurrencyValuePipe(appService);
  }

  /**
   * @param value 原始值
   * @param currency 幣別
   * @param placeholder 同 currencyValue
   * @param addPlus 同 currencyValue
   */
  transform(value: any, currency: string, placeholder?: string | string[], addPlus?: boolean): string {
    const target = (this.appService.currencies$.value || []).find((x: any) => x.currency === currency);
    // 幣別清單尚未載入時無法判斷是否為法幣，但穩定幣可直接認定，避免初次渲染先閃出多位小數
    const twoDecimal = target ? isTwoDecimalCurrency(currency, !!target.isDigital) : isStablecoin(currency);
    if (!twoDecimal) {
      return this.currencyValuePipe.transform(value, currency, placeholder, addPlus);
    }

    // currencyValue 對小數是截斷，先四捨五入再交給它處理千分位；空值保留原樣讓 placeholder 生效
    const numeric = Number(value);
    const rounded =
      value === '' || value === null || value === undefined || !Number.isFinite(numeric)
        ? value
        : roundAmount(numeric, FIAT_AMOUNT_DECIMALS);

    return trimTrailingZeros(
      String(this.currencyValuePipe.transform(rounded, currency, placeholder, addPlus, FIAT_AMOUNT_DECIMALS)),
    );
  }
}
